/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { CanvasContentCellModelHelper } from "./CanvasContentCellModelHelper";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasSummaryCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasSummaryCellPresenter, _super);
    function CanvasSummaryCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasSummaryCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasSummaryCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.av("ResolvedSummaryLabel") || a.av("ResolvedSummaryValue")) {
                this.d.dc(b.kn);
                this.d.ck(b.kp);
            }
            if (a.av("SummaryLabelTextColor")) {
                var c = CanvasContentCellModelHelper.e(b.ku);
                this.d.dd(c);
            }
            if (a.av("FontInfo")) {
                this.d.de(b.af);
            }
            CanvasContentCellModelHelper.a(this.a.bl, b, this.a);
        }
    };
    CanvasSummaryCellPresenter.$t = markType(CanvasSummaryCellPresenter, 'CanvasSummaryCellPresenter', CanvasCellPresenterBase.$);
    return CanvasSummaryCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasSummaryCellPresenter };
//# sourceMappingURL=CanvasSummaryCellPresenter.js.map
